import trelloBackbone from './src/trello-backbone';

// eslint-disable-next-line import/no-default-export
export default trelloBackbone;
